export const COOKIES_NOTICE_COOKIE_NAME = "cookie-accepted";
export const COOKIES_NOTICE_COOKIE_EXPIRATION = 30;

export const MIXPANEL_COOKIE_NAME = "ah_mp_id";
export const MIXPANEL_COOKIE_EXPIRATION = 365;

export const RETURNING_USERS_POST_ELIGIBILITY_COOKIE_NAME = "last_enquiry";
export const RETURNING_USERS_PRE_ELIGIBILITY_COOKIE_NAME = "ah-saved-pre-eligibility-session-exists";

export const RETURNING_USERS_NOTIFICATION_CLOSED_COOKIE_NAME = "returning_users_notification_closed";
export const RETURNING_USERS_NOTIFICATION_CLOSED_COOKIE_EXPIRATION = 30;
